import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import CarouselSect from "../components/carousel/crouselSection";
import AboutSection from "../components/about/aboutSection";
import Problem from "../components/problem/problem";
import Faq from "../components/faq/faq";
import StepsSection from "../components/steps/steps";
import Foot from "../components/foot/foot";

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <CarouselSect />
    <AboutSection />
    <Problem />
    <Faq />
    <StepsSection />
    <Foot />
  </Layout>
)

export default IndexPage
